function setLocalStoragefromProductPage() {
    let productForm = $(".product-form, product-form"),
        productTile = $(".header-product-title").text().trim(),
        productid = $(productForm).find('input[name="id"]').data("productid"),
        subscription_Options = $(".rc-selling-plans-dropdown__select option"),
        optionArray = [];
    subscription_Options.map((mapindex, option) => {
        let selling_plan = $(option).text(),
            plan_id = $(option).val();
        optionArray.push({
            id: plan_id,
            plan: selling_plan
        })
    });
    let productData = {
            id: productid,
            title: productTile,
            subscription_options: optionArray
        },
        cart = JSON.parse(localStorage.getItem("cartProduct")) || [],
        existingProductIndex = cart.findIndex(item => item.id === productid);
    existingProductIndex !== -1 ? cart[existingProductIndex] = productData : cart.push(productData), localStorage.setItem("cartProduct", JSON.stringify(cart))
}
$(document).ready(function() {
    let intervalId = setInterval(function() {
        $(".rc-selling-plans-dropdown__select option").length !== 0 && (setLocalStoragefromProductPage(), clearInterval(intervalId))
    }, 1e3);
    setTimeout(function() {
        clearInterval(intervalId)
    }, 5e4);

    function Checksubscription() {
        var radioValue = $(".recharge_subscription_widget .product-form__radio:checked").val();
        radioValue == "one-time" ? ($(".onetime_per_price").show(), $(".subscription_per_price").hide()) : ($(".onetime_per_price").hide(), $(".subscription_per_price").show())
    }

    function Updateprices() {
        setTimeout(function() {
            var SubPrice = $(".subscription-radio .rc-radio__price").html(),
                onetimePrice = $(".onetime-radio .rc-radio__label").text().replace("One-time Purchase", "");
            $(".onetime_price").html(onetimePrice), $(".subscribtion_price").html(SubPrice);
            const selectedVariant = Number($('input[name="id"]').val()),
                // variantJSON = $.parseJSON($("variant-radios script").text());
                variantJSON = $.parseJSON($("[data-variant-picker] script#productVariants").text());
          
            let compareAtPrice = 0,
                otPrice = 0,
                finalPrice = 0,
                finone = 0;
            for (i of variantJSON) i.id == selectedVariant && (compareAtPrice = parseFloat(i.compare_at_price), otPrice = parseFloat(i.price), finalPrice = (compareAtPrice / 100).toFixed(2), finone = onetimePrice.replace("$", ""));
            otPrice === compareAtPrice ? ($("#product__compareprices").hide(), $(".product__compareprice").hide()) : ($("#product__compareprices").show(), $(".product__compareprice").show()), parseFloat(finalPrice) !== parseFloat(finone) && finalPrice > 0 && ($("#product__compareprices").text("$" + finalPrice), $(".product__compareprice").text("$" + finalPrice))
        }, 500)
    }
    // $(document).on("click", ".product-form__input .custom-radio", function() {
    $(document).on("click", ".variant-picker__input .custom-radio", function() {
      setTimeout(function() {
        const selectedVariant = $('product-form input[name="id"]').val();
        $('.bundle-badge.custom_tag, .bundle-badge.one-time-badge').addClass('hidden');
        $('.bundle-badge.custom_tag[data-variant-id="'+selectedVariant+'"], .bundle-badge.one-time-badge[data-variant-id="'+selectedVariant+'"]').removeClass('hidden');
      }, 300);

      var selectElements = document.querySelectorAll('.custom-select__selector');
      
      selectElements.forEach(function(selectElement) {
        // Select the first option in the select element
        var firstOption = selectElement.options[0];
        if (firstOption) {
          firstOption.selected = true;
      
          // Create and dispatch a change event
          var event = new Event('change', {
            bubbles: true,
            cancelable: true,
          });
      
          selectElement.dispatchEvent(event);
        }
      });
      
        Checksubscription(), document.querySelector(".rc-template__radio") && Updateprices()
    }), $(".product-form__radio:checked").val() == "one-time" ? ($(".onetime-radio .rc-radio__input").trigger("click"), $(".subscribe_data").hide(), $(".onetime_per_price").show(), $(".subscription_per_price").hide()) : ($(".subscription-radio .rc-radio__input").trigger("click"), $(".subscribe_data").show(), $(".onetime_per_price").hide(), $(".subscription_per_price").show()), $(document).on("click", ".product-form__radio", function() {
      $(this).val() == "one-time" ? ($(".onetime-radio .rc-radio__input").trigger("click"), $(".subscribe_data").hide(), $(".onetime_per_price").show(), $(".subscription_per_price").hide(),$('.custom-select__selector option:first').attr('selected','selected')) : ($(".subscription-radio .rc-radio__input").trigger("click"), $(".subscribe_data").show(), $(".onetime_per_price").hide(), $(".subscription_per_price").show())
    });
    $(document).on("change", ".product-form__radio", function() {
      var selectElements = document.querySelectorAll('.custom-select__selector');
      
      selectElements.forEach(function(selectElement) {
        // Select the first option in the select element
        var firstOption = selectElement.options[0];
        if (firstOption) {
          firstOption.selected = true;
      
          // Create and dispatch a change event
          var event = new Event('change', {
            bubbles: true,
            cancelable: true,
          });
      
          selectElement.dispatchEvent(event);
        }
      });
    });
    var interval = setInterval(function() {
            if (document.querySelector(".rc-template__radio")) {
                $(".recharge_subscription_widget").show();
                var discount = $(".subscription-radio .rc-radio__subscription").text(),
                    discountMatch = discount.match(/(\d+)%/),
                    percentage = discountMatch[1],
                    onetimePrice = $(".onetime-radio .rc-radio__label").text().replace("One-time Purchase", ""),
                    SubPrice = $(".subscription-radio .rc-radio__price").html();
                $(".discount_value").html(percentage + "%"), $(".subscribtion_price").html(SubPrice), $(".onetime_price").html(onetimePrice);
                const selectedVariant = Number($('input[name="id"]').val()),
                    // variantJSON = $.parseJSON($("variant-radios script").text());
                   variantJSON = $.parseJSON($("[data-variant-picker] script#productVariants").text());
                  const selectedVariant_form = $('product-form input[name="id"]').val();
                  $('.bundle-badge.custom_tag, .bundle-badge.one-time-badge').addClass('hidden');
                  $('.bundle-badge.custom_tag[data-variant-id="'+selectedVariant_form+'"], .bundle-badge.one-time-badge[data-variant-id="'+selectedVariant_form+'"]').removeClass('hidden');
                let compareAtPrice = 0,
                    otPrice = 0,
                    finalPrice = 0,
                    finone = 0;
                for (i of variantJSON) i.id == selectedVariant && (compareAtPrice = parseFloat(i.compare_at_price), otPrice = parseFloat(i.price), finalPrice = (compareAtPrice / 100).toFixed(2), finone = onetimePrice.replace("$", ""));
                parseFloat(finalPrice) !== parseFloat(finone) && finalPrice > 0 && ($("#product__compareprices").text("$" + finalPrice), $(".product__compareprice").text("$" + finalPrice)), clearInterval(interval)
            }
        }, 500),
        showinterval = setInterval(function() {
            $(".rc-template__radio").length && ($(".rc-selling-plans-dropdown__select option").each(function(index0, element0) {
                $(this).attr("data-plan-option", $(".custom-select__selector option:eq(" + index0 + ")").attr("data-plan-option"))
            }), clearInterval(showinterval))
        }, 1e3);

    //custom months/days selector
    $(document).on("change", ".custom-select__selector", function() {
        var plan = $(this).find("option:selected").data("plan-option"),
            selectedIndex = $(this).find("option:selected").index(),
            selectedIndexVal = $(".rc-selling-plans-dropdown__select option:eq(" + selectedIndex + ")").val();
        $("input[name=selling_plan]").val(selectedIndexVal), $(".rc-selling-plans-dropdown__select").val(selectedIndexVal).trigger("change")
    })
});


$(document).ready(function() {
    setTimeout(function() {
        if (active_sub = $(".rc-widget .rc-template__radio .rc-radio.subscription-radio").hasClass("rc-radio--active"), active_sub == !0) {
            var new_price = $(".rc-radio--active .rc-radio__label .rc-radio__price").html();
            $(".product-form .price_d").html(new_price), $(".variant-picker__input input").change(function() {
                setTimeout(function() {
                    var new_price2 = $(".rc-radio--active .rc-radio__label .rc-radio__price").html();
                    $(".product-form .price_d").html(new_price2)
                }, 700)
            })
        }
    }, 700), $("body").on("click", ".rc-widget .rc-template__radio .rc-radio.subscription-radio", function() {
        setTimeout(function() {
            if (active_sub = $(".rc-widget .rc-template__radio .subscription-radio").hasClass("rc-radio--active"), active_sub == !0) {
                var new_price = $(".rc-radio--active .rc-radio__label .rc-radio__price").html();
                $(".product-form .price_d").html(new_price), $(".variant-picker__input input").change(function() {
                    setTimeout(function() {
                        var new_price_var = $(".rc-radio--active .rc-radio__label .rc-radio__price").html();
                        $(".product-form .price_d").html(new_price_var)
                    }, 700)
                })
            }
        }, 700)
    }), $("body").on("click", ".rc-widget .rc-template__radio .rc-radio.onetime-radio", function() {
      console.log('three')
        setTimeout(function() {
            if (active_one_sub = $(".rc-widget .rc-template__radio .onetime-radio").hasClass("rc-radio--active"), active_one_sub == !0) {
                // var price = $('.f-price__sale .f-price-item--sale').html();
                var price = $('.onetime.option-recharge .onetime_price.money').html();
                // var price = $("#new_price .price__sale .price-item.price-item--sale").html();
                $(".product-form .price_d").html(price), $(".variant-picker__input input").change(function() {
                    setTimeout(function() {
                        // price = $("#new_price .price__sale .price-item.price-item--sale").html();
                        // price = $('.f-price__sale .f-price-item--sale').html();
                           price = $('.onetime.option-recharge .onetime_price.money').html();
                        var set_atc = $(".product-form .price_d").html(price)
                    }, 700)
                })
            }
        }, 700)
    })
});

// drawer code
$(document).ready(function(){
  $(document).on("click", "[data-update-To-Subscription]", function() {
    var variantId = $(this).attr('data-item-id');
    var line_id = $(this).parents('.m-cart-drawer--item').attr('data-index');
    var qty = parseInt($(this).attr('data-qty'));
    let subscriptionPlan = $(this).attr("data-sub-id");
    $('.m-cart-drawer--inner').addClass('al-loading-bar loading al-loading-overlay overlay-show');
    removeProduct(line_id, function() {
        addItemToCart(variantId, qty, subscriptionPlan, $(this), !0)
    })
  });

  $(document).on("change", ".ak-custom-item-subscription select.subscription-select", function() {
      $(this).attr("disabled", !0);
      let variantId = $(this).find("option:selected").attr("data-item-id"),
          sellingPlanId = $(this).find("option:selected").attr("data-sub-id"),
          line_id = $(this).parents('.m-cart-drawer--item').attr('data-index'),
          qty = parseInt($(this).find("option:selected").attr('data-item-qty'));
          removeProduct(line_id, function() {
              addItemToCart(variantId, qty, sellingPlanId, $(this), !0)
          })
  });


  function removeProduct(variantId, callback) {
    var quantity = 0;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            line: variantId,
            quantity: 0
        },
        success: function(cart) {
          callback && typeof callback == "function" && callback()
        },
        error: function(xhr, status, error) {
            // Handle error
          $('.m-cart-drawer--inner').removeClass('al-loading-bar loading al-loading-overlay overlay-show');
            console.error(error);
        }
    });
  }

  function addItemToCart(variant_id, qty, selling_plan, btn, cardreload) {
    console.log('hh')
     if(selling_plan){
       console.log('yes')
       data = {
          id: variant_id,
          quantity: qty,
          selling_plan
      };
     }else{
       console.log('no')
       data = {
          id: variant_id,
          quantity: qty
      };
     }
      
    
      jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data,
          dataType: "json",
          success: function() {
              setTimeout(function() {
                $.ajax({
                    url: window.location.href,
                    method: "GET",
                    dataType: "html",
                    success: function(htmlContent) {
                        let doc = new DOMParser().parseFromString(htmlContent, "text/html");
                        let cartDrawerElement = doc.querySelector("#MinimogCartDrawer .m-cart-drawer--inner .h-full");
                        cartDrawerElement && ($("#MinimogCartDrawer .m-cart-drawer--inner .h-full").replaceWith(cartDrawerElement.outerHTML))
                        $('.m-cart-drawer--inner').removeClass('al-loading-bar loading al-loading-overlay overlay-show');
                    },
                    error: function(error) {
                        console.error("Error fetching and modifying HTML:", error)
                    }
                });
              }, 650)
          },
         error: function(xhr, status, error) {
            // Handle error
          $('.m-cart-drawer--inner').removeClass('al-loading-bar loading al-loading-overlay overlay-show');
            console.error(error);
         }
      });
  }
});
// $(document).ready(function() {
//     $("label.subscribe-field").click(function() {
//         $("label.subscribe-field").removeClass("subscribe-active"), $(this).addClass("subscribe-active")
//     })
// }), $(document).ready(function() {
//     $(".product-form__input.Fragrance input").change(function() {
//         var set_attr = $(this).attr("value");
//         $(".product-form__input.Fragrance .form__label strong").html(":&nbsp" + set_attr)
//     }), $(".product-form__input.Fragrance input").each(function() {
//         if ($(this).is(":checked")) {
//             var active_value = $(this).attr("value");
//             $(".product-form__input.Fragrance .form__label strong").html(":&nbsp" + active_value)
//         }
//     })
// });


//for future
// const xhttp = new XMLHttpRequest;
// xhttp.onload = function() {
//     try {
//         const country = JSON.parse(this.responseText).country;
//         showShippingText(country), console.log(JSON.parse(this.responseText).country)
//     } catch (error) {
//         console.error("Error parsing response:", error)
//     }
// }, xhttp.onerror = function() {
//     console.error("Error fetching data from the API")
// }, xhttp.open("GET", "https://ipapi.co/json/"), xhttp.send();

// function showShippingText(country) {
//     $(".shippingtext-AU, .shippingtext-US, .shippingtext-NZ").hide(), country === "AU" ? $(".shippingtext-AU").show() : country === "US" ? $(".shippingtext-US").show() : country === "NZ" && $(".shippingtext-NZ").show()
// }